import { useStaticQuery, graphql } from "gatsby"

export const useAuthors = () => {
  const {
    allAuthorsYaml: { authors = [] },
  } = useStaticQuery(
    graphql`
      query AllAuthorsQuery {
        allAuthorsYaml {
          authors: nodes {
            ...author
          }
        }
      }
    `
  )

  if (authors.length) {
    return authors
  }

  throw new Error("Please specify at least one author in authors.yaml")
}

export const useDefaultAuthor = (author) => {
  const [firstAuthor] = useAuthors()
  return author || firstAuthor
}
